import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/context/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import ScrollToTop from '@/components/ScrollToTop';

const News: React.FC = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  // News state as an array
  const [newsList, setNewsList] = useState<any[]>([]);

  useEffect(() => {
    const fetchText = (path: string) => fetch(path).then(r => r.text());

    // News data config (newest first)
    const newsConfig = [
      {
        id: 'day-of-abai',
        image: '/news/16/abai.jpeg',
        alt: language === 'ru' ? 'День Абая' : 'Абай күні',
        title: language === 'ru'
          ? '10 августа – День Абая'
          : '10 тамыз – Абай күні',
        preview: language === 'ru'
          ? 'Абай Кунанбаев – великий мыслитель, поэт, просветитель, один из основоположников национальной литературы, чьё наследие остаётся духовным ориентиром и сегодня.'
          : 'Абай Құнанбайұлы – қазақ халқының рухани әлемін биіктеткен ұлы ойшыл, ақын, ағартушы, оның мұрасы бүгінгі күнге де рухани бағдар бола алады.',
        onClick: () => navigate('/news/day-of-abai'),
        isStatic: true,
      },
       {
         id: 'new-article-15',
         image: '/news/15/photo_main.jpg',
         alt: language === 'ru'
           ? 'Спортивный медицинский центр переехал на новый адрес'
           : 'Спорттық медициналық орталық жаңа мекенжайға көшті',
         title: language === 'ru'
           ? 'Спортивный медицинский центр переехал на новый адрес'
           : 'Спорттық медициналық орталық жаңа мекенжайға көшті',
         preview: language === 'ru'
           ? 'Сообщаем, что Спортивный медицинский центр города Астаны переехал на новый адрес: проспект Улы Дала, 35А.'
           : 'Астана қаласының Спорттық медициналық орталығының жаңа мекенжайға көшкенін хабарлаймыз: Ұлы Дала даңғылы, 35А.',
         onClick: () => navigate('/news/new-article-15'),
         isStatic: true,
       },
      // ── NEW: Article 14 — Voting Protocols ──
      {
        id: 'new-article-14',
        image: '/news/3/photoes/1.jpeg',
        alt: language === 'ru'
          ? 'Протоколы голосования конкурсной комиссии'
          : 'Конкурстық комиссияның дауыс беру хаттамалары',
        title: language === 'ru'
          ? 'Протоколы голосования конкурсной комиссии'
          : 'Конкурстық комиссияның дауыс беру хаттамалары',
        preview: language === 'ru'
          ? '10 марта 2026 года конкурсная комиссия провела голосование по кандидатам на должность руководителя ГККП «Спортивный медицинский центр города Астаны».'
          : '2026 жылғы 10 наурызда конкурстық комиссия «Астана қаласының Спорттық медициналық орталығы» МККҚ басшысы бос лауазымына үміткерлер бойынша дауыс берді.',
        onClick: () => navigate('/news/new-article-14'),
        isStatic: true,
      },
      // ── NEW: Article 13 — Protocol #1 & Interview Schedule ──
      {
        id: 'new-article-13',
        image: '/news/3/photoes/1.jpeg',
        alt: language === 'ru'
          ? 'Протокол №1 заседания конкурсной комиссии и график собеседования'
          : 'Конкурстық комиссия отырысының №1 хаттамасы және әңгімелесу кестесі',
        title: language === 'ru'
          ? 'Протокол №1 заседания конкурсной комиссии и график собеседования'
          : 'Конкурстық комиссия отырысының №1 хаттамасы және әңгімелесу кестесі',
        preview: language === 'ru'
          ? '04 марта 2026 года состоялось заседание конкурсной комиссии по отбору кандидатов на занятие вакантной должности руководителя ГККП «Спортивный медицинский центр города Астаны».'
          : '2026 жылғы 04 наурызда «Астана қаласының Спорттық медициналық орталығы» МККҚ басшысы бос лауазымына үміткерлерді іріктеу жөніндегі конкурстық комиссияның отырысы өтті.',
        onClick: () => navigate('/news/new-article-13'),
        isStatic: true,
      },
       {
        id: 'fencing-championship',
        image: '/news/3/photoes/1.jpeg',
        alt: language === 'ru' ? 'Конкурс на должность руководителя ГККП «Спортивный медицинский центр города Астаны».' : language === 'kz' ? 'Астана қаласы әкімдігінің «Спорттық медициналық орталығы» МКҚК басшысы бос лауазымына конкурс.' : 'Астана қаласы әкімдігінің «Спорттық медициналық орталығы» МКҚК басшысы бос лауазымына конкурс.',
        title: language === 'ru' ? 'Конкурс на должность руководителя ГККП «Спортивный медицинский центр города Астаны».' : language === 'kz' ? 'Астана қаласы әкімдігінің «Спорттық медициналық орталығы» МКҚК басшысы бос лауазымына конкурс.' : 'Астана қаласы әкімдігінің «Спорттық медициналық орталығы» МКҚК басшысы бос лауазымына конкурс.',
        textPath: `/news/${language === 'ru' ? '3/3_rus.txt' : '3/3_kaz.txt'}`,
        onClick: () => navigate('/news/fencing-championship'),
       },
       {
        id: 'new-article-12',
        image: '/news/12/photos/1.png',
        alt: language === 'ru' ? 'The 2025 Kazakhstan Volleyball Cup has concluded in Astana.' : 'The 2025 Kazakhstan Volleyball Cup has concluded in Astana.',
        title: language === 'ru' ? 'В Астане завершился Кубок Казахстана по волейболу сезона 2025 года' : 'Астанада 2025 маусымындағы волейболдан Қазақстан Кубогы аяқталды',
        textPath: `/news/12/${language === 'ru' ? '12_rus.txt' : '12_kaz.txt'}`,
        onClick: () => navigate('/news/new-article-12'),
      },
      {
        id: 'youth-prize-daryn-7',
        image: '/news/7/photoes/1.jpeg',
        alt: language === 'ru' ? 'Анти Call-Центр в Астане: Новый Рубеж Защиты Граждан от Интернет-Мошенников' : language === 'kz' ? 'Интернет-Алаяқтарға Қарсы Күрес Және Азаматтарды Қорғаудың Жаңа Шебі Астанада' : 'Anti Call-Center in Astana: A New Frontier in Protecting Citizens from Online Fraud',
        title: language === 'ru' ? 'Анти Call-Центр в Астане: Новый Рубеж Защиты Граждан от Интернет-Мошенников' : language === 'kz' ? 'Интернет-Алаяқтарға Қарсы Күрес Және Азаматтарды Қорғаудың Жаңа Шебі Астанада' : 'Anti Call-Center in Astana: A New Frontier in Protecting Citizens from Online Fraud',
        textPath: `/news/7/${language === 'ru' ? '7_rus.txt' : '7_kaz.txt'}`,
        onClick: () => navigate('/news/youth-prize-daryn-7'),
      },
      {
        id: 'new-article-11',
        image: '/news/11/photos/1.jpg',
        alt: language === 'ru' ? 'Training of specialists in emergency medical care programs.' : 'Training of specialists in emergency medical care programs.',
        title: language === 'ru' ? 'Обучение врачей детско-юношеских спортивных школ по неотложной помощи' : 'Жедел медициналық көмек бағдарламалары бойынша мамандарды оқыту.',
        textPath: `/news/11/${language === 'ru' ? '11_rus.txt' : '11_kaz.txt'}`,
        onClick: () => navigate('/news/new-article-11'),
      },
      {
        id: 'berik-asylov',
        image: language === 'ru' ? '/news/10/photoes/1.jpeg' : '/news/10/photoes/1.jpeg',
        alt: '',
        title: '',
        textPath: language === 'ru' ? '/news/10/10_rus.txt' : '/news/10/10_kaz.txt',
        onClick: () => navigate('/news/berik-asylov'),
      },
      {
        id: 'new-article-9',
        image: language === 'ru' ? '/news/9/rus/photos/1.jpg' : '/news/9/kaz/photos/1.jpg',
        alt: '',
        title: '',
        textPath: `/news/9/${language === 'ru' ? 'rus' : 'kaz'}/9_${language === 'ru' ? 'rus' : 'kaz'}.txt`,
        onClick: () => navigate('/news/new-article-9'),
      },
      {
        id: 'sports-school-opening',
        image: '/news/4/photoes/1.jpg',
        alt: language === 'ru' ? 'Врачи Центра спортивной медицины обеспечили полное медицинское сопровождение международного турнира Open President Cup по настольному теннису в Астане.' : language === 'kz' ? 'Спорттық медицина орталығының дәрігерлері Астанадағы үстел теннисінен Open President Cup халықаралық турнирінің толық медициналық сүйемелдеуін қамтамасыз етті.' : 'Doctors from the Center for Sports Medicine provided full medical support for the Open President Cup International Table Tennis Tournament in Astana.',
        title: language === 'ru' ? 'Врачи Центра спортивной медицины обеспечили полное медицинское сопровождение международного турнира Open President Cup по настольному теннису в Астане.' : language === 'kz' ? 'Спорттық медицина орталығының дәрігерлері Астанадағы үстел теннисінен Open President Cup халықаралық турнирінің толық медициналық сүйемелдеуін қамтамасыз етті.' : 'Doctors from the Center for Sports Medicine provided full medical support for the Open President Cup International Table Tennis Tournament in Astana.',
        textPath: `/news/${language === 'ru' ? '4/4_rus.txt' : '4/4_kaz.txt'}`,
        onClick: () => navigate('/news/sports-school-opening'),
      },
      {
        id: 'world-boxing-cup',
        image: '/news/5/photoes/1.jpeg',
        alt: language === 'ru' ? 'World Boxing Cup: Astana 2025' : language === 'kz' ? 'World Boxing Cup: Astana 2025' : 'World Boxing Cup: Astana 2025',
        title: language === 'ru' ? 'World Boxing Cup: Astana 2025 — Кубок мира по боксу в столице Казахстана' : language === 'kz' ? 'World Boxing Cup: Astana 2025 — Қазақстан астанасында бокстан Әлем кубогы' : 'World Boxing Cup: Astana 2025 — Boxing World Cup in Kazakhstan\'s capital',
        textPath: `/news/${language === 'ru' ? '5/5_rus.txt' : '5/5_kaz.txt'}`,
        onClick: () => navigate('/news/world-boxing-cup'),
      },
      {
        id: 'world-boxing-cup-6',
        image: '/news/6/photos/1.jpeg',
        alt: language === 'ru' ? 'World Boxing Cup – Astana 2025' : 'World Boxing Cup – Astana 2025',
        title: language === 'ru' ? 'World Boxing Cup – Astana 2025: уверенная победа Казахстана и вклад спортивной медицины' : 'World Boxing Cup – Astana 2025: Қазақстанның сенімді жеңісі және спорттық медицинаның үлесі',
        textPath: `/news/6/${language === 'ru' ? '6_rus.txt' : '6_kaz.txt'}`,
        onClick: () => navigate('/news/world-boxing-cup-6'),
      },
      {
        id: 'presidential',
        image: '/lovable-uploads/2bce0ced-5737-4203-bbe6-6b54ee8ddef2.png',
        alt: language === 'ru' ? 'Президентский молодежный кадровый резерв' : language === 'kz' ? 'Президенттік жастар кадр резерві' : 'Presidential Youth Personnel Reserve',
        title: t('news.presidential.title'),
        preview: t('news.presidential.content'),
        onClick: () => navigate('/news/presidential-reserve'),
        isStatic: true,
      },
    ];

    // Fetch all dynamic news texts
    Promise.all(
      newsConfig.map(async (item) => {
        let currentTitle = item.title;
        let currentPreview = item.preview;
        let currentAlt = item.alt;
        
        if (item.textPath) {
          try {
            const text = await fetchText(item.textPath);
            const lines = text.split('\n');
            if (!currentTitle) {
              currentTitle = lines[0];
            }
            if (!currentAlt) {
              currentAlt = currentTitle;
            }
            currentPreview = lines.slice(1).join('\n');
          } catch {
            currentPreview = '';
          }
        }
        
        return { ...item, title: currentTitle, preview: currentPreview, alt: currentAlt };
      })
    ).then(setNewsList);
  }, [language, navigate, t]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-grow">
        {/* Main News Section */}
        <section className="min-h-screen p-3 sm:p-4 md:p-6 lg:p-8 bg-white">
          <div className="container mx-auto w-full">
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-serif font-bold text-gov-blue mb-4 sm:mb-6 md:mb-8 lg:mb-12 text-center px-2">
              {t('news.title')}
            </h1>
            {/* News Articles in Three Columns */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 items-stretch">
              {newsList.map((item) => (
                <Card key={item.id} className="shadow-lg border-0 hover:shadow-xl transition-shadow overflow-hidden flex flex-col h-full">
                  <div className="w-full h-32 sm:h-40 md:h-48 lg:h-56 overflow-hidden flex-shrink-0">
                    <img 
                      src={item.image}
                      alt={item.alt}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <CardContent className="p-3 sm:p-4 md:p-6 flex flex-col flex-grow">
                    <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-serif font-bold text-gray-800 mb-2 sm:mb-3 md:mb-4 leading-tight">
                      {item.title}
                    </h2>
                    <div className="text-gray-700 leading-relaxed mb-3 sm:mb-4 md:mb-6 text-xs sm:text-sm md:text-base flex-grow">
                      <PreviewWithLinks text={item.preview?.substring(0, 100) + '...'} />
                    </div>
                    <Button 
                      onClick={item.onClick}
                      variant="outline"
                      className="w-full border-gov-blue text-gov-blue hover:bg-gov-blue hover:text-white transition-colors text-xs sm:text-sm md:text-base py-2 md:py-3 px-4 md:px-6 mt-auto"
                    >
                      {t('news.learnMore')}
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default News;

function PreviewWithLinks({ text }: { text: string }) {
  if (!text) return null;
  const urlRegex = /(https?:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=%]+|www\.[\w\-._~:/?#[\]@!$&'()*+,;=%]+)/gi;
  const parts = text.split(urlRegex);
  return (
    <span className="line-clamp-3 sm:line-clamp-4">
      {parts.map((part, i) => {
        if (urlRegex.test(part)) {
          const href = part.startsWith('http') ? part : `https://${part}`;
          return <a key={i} href={href} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline break-all">{part}</a>;
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
}
